import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

import { JobOrderApplicationFragmentFragmentDoc } from '../fragments/jobOrderApplication.fragment.generated';

export type ListJobOrderFragment = {
  __typename?: 'JobOrderHubType';
  jobOrderId: string;
  jobOrderLabel: string;
  assignmentDate?: any | null;
  locationPreference?: string | null;
  workMode?: Types.WorkModeEnum | null;
  rateRangeFrom?: number | null;
  rateRangeTo?: number | null;
  isSaved?: boolean | null;
  seniority?: Types.SeniorityLevelEnum | null;
  experienceYears?: number | null;
  minEnglishLevel?: Types.LanguageLevelEnum | null;
  isAIRAvailable: boolean;
  application?: {
    __typename?: 'JobOrderApplicationHubType';
    applicationId: string;
    jobOrderId: string;
    publicOfferId?: string | null;
    createdAt: string;
    meetingDates: Array<string>;
    ciDate?: string | null;
    cqDate?: string | null;
    status: Types.JobOrderApplicationStatusEnum;
    processStatus: Types.JobOrderApplicationProcessStatusEnum;
    prevProcessStatus?: Types.JobOrderApplicationProcessStatusEnum | null;
    meetingUrl?: string | null;
    isViewedByExpert: boolean;
    handlerId?: string | null;
    preppingId?: string | null;
    flow?: Types.JobOrderApplicationFlowEnum | null;
    contactByPhone?: boolean | null;
    isPreferencesFinished: boolean;
    hasActiveAirInterviewInvitation: boolean;
    preferences?: {
      __typename?: 'JobOrderApplicationPreferencesType';
      location?: string | null;
      workType?: Types.WorkModeEnum | null;
      rateDesired?: number | null;
      linkedInUrl?: string | null;
      availability?: Types.ExpertAvailabilityEnum | null;
      noticeLength?: number | null;
      experienceYears?: number | null;
      englishLevel?: Types.LanguageLevelEnum | null;
      skillsMustHave?: Array<{
        __typename?: 'PreferencesSkillType';
        tagId: string;
        weight: number;
      }> | null;
      skillsNiceToHave?: Array<{
        __typename?: 'PreferencesSkillType';
        tagId: string;
        weight: number;
      }> | null;
    } | null;
  } | null;
};

export const ListJobOrderFragmentDoc = gql`
  fragment ListJobOrder on JobOrderHubType {
    jobOrderId
    jobOrderLabel
    assignmentDate
    locationPreference
    workMode
    rateRangeFrom
    rateRangeTo
    isSaved
    seniority
    experienceYears
    minEnglishLevel
    application {
      ...JobOrderApplicationFragment
    }
    isAIRAvailable
  }
  ${JobOrderApplicationFragmentFragmentDoc}
`;
